import React, { useState } from "react";
import Layout from "../../../component/Layout";
import perfomanceChart from "../../../images/perfomanceChart.png";
import RRTestHeader from "../Test/RRTestHeader";

const performanceData = [
  { title: "Strength & Speed", image: perfomanceChart },
  { title: "Power", image: perfomanceChart },
  { title: "Speed & Strength", image: perfomanceChart },
  { title: "Speed", image: perfomanceChart },
];
const RRPerformance = () => {
  const [openIndex, setOpenIndex] = useState(null); 

  const toggleAccordion = (index: any) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <Layout>
      <div className="bg-[#F6F6F6] h-full pb-5 overflow-y-auto">
      <RRTestHeader />
        <div className="w-full max-w-2xl mx-auto mb-[30px]">
          {performanceData.map((section, index) => (
            <div
              key={index}
              className={`relative border-b border-black/20 last:border-none ${
                openIndex === index && "!border-none"
              }`}
            >
              <div
                className={`${
                  openIndex === index && "!bg-[#ECECEC]"
                } flex flex-col py-[15px] px-5 bg-transparent`}
              >
                <button
                  className={`text-black text-start text-base font-normal flex flex-row justify-between gap-3 items-center`}
                  onClick={() => toggleAccordion(index)} 
                >
                  <span>{section.title}</span>
                  {openIndex === index ? (
                    <span className="rotate-180">
                      <ArrowD />
                    </span>
                  ) : (
                    <ArrowD />
                  )}
                </button>

                {openIndex === index && ( 
                  <div className="pt-[15px] h-[233px] pb-3">
                    <img
                      src={section.image}
                      alt={section.title}
                      className="w-fit h-fit mx-auto"
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default RRPerformance;

const ArrowD = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
    >
      <path
        d="M13 1L7 7L1 1"
        stroke="#000"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const ArrowL = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M7 13L1 7L7 1"
        stroke="#FFFEFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
